<template>
    <div class="custom-background">
        <div class="min-h-screen flex items-center justify-center p-2">
    
            <div class="w-full max-w-md">
                <!-- Header Row -->
    
                <CContainer>
                    <div style="width: 100%;margin: 0 auto;">
                        <!-- Header Row -->
                        <div style="position: relative; display: flex; align-items: center; justify-content: center; margin-bottom: 1rem;">
    
                            <!-- Back Button -->
                            <img src="@/assets/back.png" alt="Back" style="width: 24px; height: 24px;position: absolute; left: 0;" />
    
                            <!-- Title -->
                            <div style="font-weight: 600; font-size: 20px; text-align: center;">
                                Sensor Assignment Update
                            </div>
                        </div>
                    </div>
                    <CCard class="rounded-24 p-4" style="border:none">
                        <div class="flex flex-col items-center">
                            <div class="relative w-40 h-40 mb-4">
                                <img src="@/assets/plant.png" alt="Plant" class="h-full object-contain" style="max-height:300px;max-width:100%" />
                            </div>
    
                            <!-- Centered Button Row - FORCE INLINE NO WRAP -->
                            <div class="w-full">
                                <div class="inline-flex items-center gap-2 px-2" style="white-space: nowrap; min-width: max-content;">
                                    <!-- Temperature Button -->
                                    <button class="bg-blue-500 text-white px-4 py-2 rounded-full text-sm flex items-center gap-2">
          <font-awesome-icon icon="thermometer-half" />
          24 °C
        </button>
    
                                    <!-- Circle Buttons -->
                                    <button class="circle-btn m-1">
          <img src="@/assets/leave.png" alt="leaf" class="icon" />
        </button>
                                    <button class="circle-btn m-1">
          <img src="@/assets/water.png" alt="drop" class="icon" />
        </button>
                                    <button class="circle-btn m-1">
          <img src="@/assets/sun.png" alt="sun" class="icon" />
        </button>
                                    <button class="circle-btn m-1">
          <img src="@/assets/battery.png" alt="signal" class="icon" />
        </button>
                                </div>
                            </div>
                        </div>
                    </CCard>
                    <CCard class="rounded-24 p-4 mt-4 w-full text-left" style="border: none;">
                        <div class="max-w-[500px] mx-auto space-y-4 text-left">
                            <div>
                                <label class="text-sm text-gray-500">Update sensor location on the field easily.</label>
                                <br />
                                <label class="block font-medium text-gray-700 font-color-0F0F0F">Date & Time</label>
                                <p class="text-sm text-gray-500 mb-1 text-muted">Auto-filled with current date & time.</p>
                                <input type="text" class="w-full px-3 py-2 rounded-lg bg-gray-100" :value="currentDateTime" disabled style="border-radius: 12px; background: rgba(0, 124, 239, 0.10);color:#007CEF;border:none" />
                            </div>
    
                            <div>
                                <label class="block font-medium text-gray-700 mt-3 font-color-0F0F0F">Sensor ID</label>
                                <p class="text-sm text-gray-500 mb-1 text-muted">Select the sensor you want to move.</p>
                                <select
    v-model="selectedSensorId"
    class="w-full px-3 py-2 border border-gray-300 rounded-lg"
  >
    <option disabled value="">Select Available Sensor IDs</option>
    <option v-for="id in sensorIds" :key="id" :value="id">{{ id }}</option>
  </select>
                            </div>
    
                            <div>
                                <label class="block font-medium text-gray-700 mt-3">Pot ID</label>
                                <p class="text-sm text-gray-500 mb-1 text-muted">Select the new pot to assign the sensor.</p>
                                <select
  v-model="selectedPotId"
  class="w-full px-3 py-2 border border-gray-300 rounded-lg"
>
  <option disabled value="">Select Available Pot IDs</option>
  <option
    v-for="pot in potIds"
    :key="pot.id"
    :value="pot.id"
  >
    {{ pot.potName }}
  </option>
</select>
                            </div>
    
                            <button class="bg-blue-600 text-white py-2 rounded-full font-semibold hover:bg-blue-700 mt-3" block style="width:100%" @click="submitAssignment">
          Update
        </button>
                        </div>
                    </CCard>
                </CContainer>
    
                <!-- Form Fields -->
    
            </div>
        </div>
    </div>
</template>

<script>
import { CCard, CContainer } from '@coreui/vue'

export default {
    components: { CCard, CContainer },
    data() {
        return {
          currentDateTime: null,
          sensorIds: [],      // to store unique sensor IDs
          selectedSensorId: null, // for v-model
          sensors: [],
          potIds: [],                 // 👈 Add this
          selectedPotId: null,
          sensorReadingId: 0,
          dateInterval: null
          
        }
    },
    mounted() {
        this.GetListReading();
        this.GetListPot();
        this.currentDateTime = this.getLocalDateTime();
       // this.generatePotIds();
        this.updateDateTime(); // initial set
        this.dateInterval = setInterval(this.updateDateTime, 1000); // refresh every 1s
    },
    beforeUnmount() {
      clearInterval(this.dateInterval); // cleanup interval
    },
    methods: {
        GetListReading() {
            this.$API.get(this.$GetListProduct)
                .then((response) => {
                    if (response.status === 200 && response.data) {
                        this.sensors = response.data
                        const uniqueSensorIds = [...new Set(response.data.map(item => item.sensorId))]

                        this.sensorIds = uniqueSensorIds

                        const latest = [...this.sensors].sort((a, b) => b.id - a.id)[0]
                        if (latest) {
                          this.sensorReadingId = latest.id
                        }
                    }
                })
                .catch((error) => {
                    console.error('Error:', error)
                })
        },
        getLocalDateTime() {
          const now = new Date();
          return now.getFullYear() +
            '-' + String(now.getMonth() + 1).padStart(2, '0') +
            '-' + String(now.getDate()).padStart(2, '0') +
            ' ' + String(now.getHours()).padStart(2, '0') +
            ':' + String(now.getMinutes()).padStart(2, '0');
        },
        // generatePotIds() {
        //   this.potIds = Array.from({ length: 100 }, (_, i) => i + 1)
        // },
        submitAssignment() {
          const payload = {
            dateTime: new Date(), // or: this.currentDateTime if already formatted
            sensorId: this.selectedSensorId,
            potId: this.selectedPotId,
            sensorReadingId: this.sensorReadingId
          }

          this.$API.post(this.$InsertSensorAssignment, payload)
          .then(() => {
            alert('Sensor Assignment inserted successfully!')
          })
          .catch(err => {
            console.error(err)
            alert('Insert failed')
          })
        },
        updateDateTime() {
          const now = new Date();
          this.currentDateTime = now.getFullYear() +
            '-' + String(now.getMonth() + 1).padStart(2, '0') +
            '-' + String(now.getDate()).padStart(2, '0') +
            ' ' + String(now.getHours()).padStart(2, '0') +
            ':' + String(now.getMinutes()).padStart(2, '0') +
            ':' + String(now.getSeconds()).padStart(2, '0');
        },
        GetListPot() {
          this.$API.get(this.$GetListPot)
            .then((response) => {
              if (response.status === 200 && response.data) {
                // Example response.data: [{ potId: 1 }, { potId: 2 }, ...]
                this.potIds = response.data;
              }
            })
            .catch((error) => {
              console.error('Error fetching pots:', error)
            })
        },
    }
}
</script>



